import { connect } from 'react-redux';
import { ICardAssigneesHOCProps } from './types';
import { CardAssignees } from '../../components/CardAssignees/CardAssignees';
import { EMPTY_ARRAY, IApplicationState } from '../../../../../../../../types/types';
import { getBoardPermissions } from '../../../../../../../../store/model/selectors/getBoardPermissions';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import { getAuthUser } from '../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getBoardUsersCreateSelector } from '../../../../../../../../store/model/selectors/getBoardUsers';
import { getBoardRolesSortedCreateSelector } from '../../../../../../../../store/model/board/selectors/getBoardRolesSorted';
import { TStatus } from 'app/types/model';
import { ICardAssigneesEvents, ICardAssigneesFields } from '../../components/CardAssignees/types';
import { onOpen } from './events/onOpen';

// No reselect average: 0.007 ms, calls: 418, total: 2.900 ms
// Reselect average: 0.008 ms, calls: 384, total: 2.900 ms
// isEqual average: 0.010 ms, calls: 372, total: 3.700 ms

// const analyze = new Analyze('CardAssigneesHOC');

const mapStateToProps = () => {
    const getBoardRolesSorted = getBoardRolesSortedCreateSelector();
    const getBoardUsers = getBoardUsersCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        { cardId, boardId, listId, assignees, source }: ICardAssigneesHOCProps
    ): ICardAssigneesFields => {
        const card = getCard(state, cardId);
        if (cardId && !card) return null; // KNB-4355

        // analyze.start();
        const { permissionId: authUserPermissionId } = getAuthUser(state);
        const boardUsers = assignees && assignees.length && getBoardUsers(state, boardId);
        const boardRoles = assignees && assignees.length && getBoardRolesSorted(state, boardId);
        const isReadonly = !getBoardPermissions(state, boardId).authPermissions.allowEdit;
        let props;
        if (cardId) {
            const { assignees } = card;
            const isTemplates = card.status === TStatus.STATUS_SERVICE_TEMPLATE;

            props = {
                assignees,
                authUserPermissionId,
                boardId,
                boardUsers,
                boardRoles,
                cardId,
                isReadonly,
                isTemplates,
                listId,
                source,
            };
        } else {
            props = {
                assignees: assignees.map((permissionId) => {
                    return {
                        sharedUser: boardUsers.find(user => user.permissionId === permissionId),
                        roleIds: EMPTY_ARRAY
                    };
                }),
                assigneeIds: assignees,
                authUserPermissionId,
                boardId,
                boardUsers,
                boardRoles,
                cardId,
                isReadonly,
                listId,
                source,
            };
        }
        // analyze.finish();
        return props;
    };

    return _mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId, onClose, setOpen, onChange }: ICardAssigneesHOCProps,
): ICardAssigneesEvents => {
    return {
        onClose,
        onOpen: () => dispatch(onOpen(!cardId)),
        onChange,
        setOpen,
    }
};

export const CardAssigneesHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardAssignees);

CardAssigneesHOC.displayName = 'CardAssigneesHOC';
